import { type StateCreator } from 'zustand';

export interface SelectedBusiness {
  id: string;
  name: string;
}

export type SelectedBusinessSlice = {
  selectedBusiness: SelectedBusiness | null;
  setSelectedBusiness: (business: SelectedBusiness | null) => void;
};

export const createSelectedBusinessSlice: StateCreator<
  SelectedBusinessSlice,
  [],
  [],
  SelectedBusinessSlice
> = (set) => ({
  selectedBusiness: null,
  setSelectedBusiness: (business) => set({ selectedBusiness: business }),
});
